import { baseApi } from 'components/constants/Constants';
import { request } from '../api';

export const filterContactsProductTable = (
  product,
  search,
  status,
  type,
  company,
  success,
  handleError
) => {
  const statusFilter = addRequestParameter('status', status);
  const typeFilter = addRequestParameter('type', type);

  let filters = `product.key=${product.key}&product.segment=${product.segment}&supplier.key=${product.company.key}`;

  if (typeFilter != null) {
    filters = `${filters}&${typeFilter}`;
  }

  if (statusFilter != null) {
    filters = `${filters}&${statusFilter}`;
  }

  if (company.supplier?.value && company.supplier.value !== '') {
    const supplierFilter = `supplier.key`;
    filters += `&${supplierFilter}__icontains=${company.supplier.value}`;
  }
  if (company.buyer?.value && company.buyer.value !== '') {
    const buyerFilter = `buyer.key`;
    filters += `&${buyerFilter}__icontains=${company.buyer.value}`;
  }

  const options = {
    method: 'GET',
    url: `${baseApi}/contacts?${filters}`,
    headers: { 'Content-Type': 'application/json' },
    params: {
      size: search.size,
      page: search.page
    }
  };
  request(options, success, handleError);
};

const addRequestParameter = (field, values) => {
  if (values !== null && values.length > 0) {
    const join = values.map(item => item.value).join(',');
    return `${field}__eq=${join}`;
  }
  return null;
};

export const filterContactsTable = (
  search,
  query,
  status,
  type,
  user,
  company,
  success,
  handleError
) => {
  const statusFilter = addRequestParameter('status', status);
  const typeFilter = addRequestParameter('type', type);

  let filters = '';
  let sort = '';

  if (typeFilter != null) {
    filters = '?' + typeFilter;
  }

  if (statusFilter != null) {
    filters = (filters === '' ? '?' : `${filters}&`) + statusFilter;
  }

  if (query && query.length > 0) {
    let encoded = encodeURIComponent(query);
    const productFilter = `product.name`;
    if (filters === '') {
      filters += `?${productFilter}__icontains=${encoded}`;
    } else {
      filters += `&${productFilter}__icontains=${encoded}`;
    }
  }

  if (company.supplier?.value && company.supplier.value !== '') {
    const supplierFilter = `supplier.key`;
    if (filters === '') {
      filters += `?${supplierFilter}__icontains=${company.supplier.value}`;
    } else {
      filters += `&${supplierFilter}__icontains=${company.supplier.value}`;
    }
  }
  if (company.buyer?.value && company.buyer.value !== '') {
    const buyerFilter = `buyer.key`;
    if (filters === '') {
      filters += `?${buyerFilter}__icontains=${company.buyer.value}`;
    } else {
      filters += `&${buyerFilter}__icontains=${company.buyer.value}`;
    }
  }

  if (search.sort && filters === '') {
    filters = '?';
  }
  // eslint-disable-next-line array-callback-return
  search.sort.map(item => {
    switch (item.id) {
      case 'supplier':
      case 'buyer':
        sort = `${sort}&sort=${item.id}.key,${item.desc ? 'desc' : 'asc'}`;
        break;
      case 'product':
        sort = `${sort}&sort=${item.id}.name,${item.desc ? 'desc' : 'asc'}`;
        break;
      case 'create_at':
        sort = `${sort}&sort=created_at,${item.desc ? 'desc' : 'asc'}`;
        break;
      case 'origin':
        sort = `${sort}&sort=event.name,${item.desc ? 'desc' : 'asc'}`;
        break;
      default:
        sort = `${sort}&sort=${item.id},${item.desc ? 'desc' : 'asc'}`;
    }
  });
  if (search.sort?.length === 0) {
    sort = `${sort}&sort=created_at,${'desc'}`;
  }

  const options = {
    method: 'GET',
    url: `${baseApi}/contacts${filters}${sort}`,
    headers: { 'Content-Type': 'application/json' },
    params: {
      size: search.size,
      page: search.page
    }
  };
  request(options, success, handleError);
};

export const findByKey = (key, success, handleError) => {
  const options = {
    method: 'GET',
    url: `${baseApi}/contacts/${key}`,
    headers: { 'Content-Type': 'application/json' }
  };
  request(options, success, handleError);
};

export const close = (key, success, handleError) => {
  const options = {
    method: 'POST',
    url: `${baseApi}/contacts/${key}/close`,
    headers: { 'Content-Type': 'application/json' }
  };
  request(options, success, handleError);
};
export const cancel = (key, success, handleError) => {
  const options = {
    method: 'POST',
    url: `${baseApi}/contacts/${key}/cancel`,
    headers: { 'Content-Type': 'application/json' }
  };
  request(options, success, handleError);
};

export const loadAllAssets = (contact, success, handleError) => {
  const options = {
    method: 'GET',
    url: `${baseApi}/contacts/${contact.key}/assets`,
    headers: { 'Content-Type': 'application/json' }
  };
  request(options, success, handleError);
};

export const retrieveProductAssets = (
  company,
  segment,
  product,
  success,
  handleError
) => {
  const options = {
    method: 'GET',
    url: `${baseApi}/companies/${company}/segments/${segment}/products/${product}/assets`,
    headers: { 'Content-Type': 'application/json' }
  };
  request(options, success, handleError);
};

export const uploadExistingProductAssets = (
  assets,
  product,
  contact,
  success,
  handleError
) => {
  var data = {
    product: {
      company: product.company,
      product: product.key,
      segment: product.segment
    },
    assets: assets
  };
  const options = {
    method: 'POST',
    url: `${baseApi}/contacts/${contact}/assets`,
    headers: { 'Content-Type': 'application/json' },
    data: data
  };
  request(options, success, handleError);
};

export const downloadContactAsset = (contact, asset, success, handleError) => {
  const options = {
    method: 'GET',
    url: `${baseApi}/contacts/${contact.key}/assets/${asset.key}/download`,
    headers: {},
    responseType: 'blob'
  };
  request(options, success, handleError);
};

export const uploadContactAsset = (
  contact,
  asset,
  file,
  success,
  handleError
) => {
  let data = new FormData();
  data.append(
    'asset',
    new Blob([JSON.stringify(asset)], { type: 'application/json' })
  );
  data.append('content', file);
  const options = {
    method: 'POST',
    url: `${baseApi}/contacts/${contact.key}/assets`,
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    data: data
  };

  request(options, success, handleError);
};
export const findCompanyOptionsContactCenter = (
  search,
  success,
  handleError
) => {
  const defaultParams = 'operator=OR&fields=name,key&sort=name,asc';
  const filters = `&name__icontains=${search}&key__icontains=${search}`;
  const options = {
    method: 'GET',
    url: `${baseApi}/contacts/companies?${defaultParams}${filters}`,
    headers: { 'Content-Type': 'application/json' },
    params: {
      size: 15,
      page: 0
    }
  };

  request(options, success, handleError);
};

export const fetchLastRequest = (requestType, handleSuccess, handleError) => {
  const options = {
    method: 'GET',
    url: `${baseApi}/contacts/last?type=${requestType}`,
    headers: { 'Content-Type': 'application/json' }
  };

  request(options, handleSuccess, handleError, undefined, undefined);
};
